<div class="dialog-container-W750-H600">
  <div class="mb-3 flex justify-between">
    <p class="text-2xl font-bold" style="margin: 0px; position: relative; text-align: center; width: -webkit-fill-available; left: 12px">
      Manage Premium Encryption Key
    </p>

    <button type="button" class="close add-close-button" style="position: relative; top: -6px" data-dismiss="modal" (click)="closeDialog()">
      <span style="font-size: 24px; font-weight: 600; color: #707070" class="material-icons icons-close-mobile">close</span>
    </button>
  </div>
  <p class="text-[#515765] font-normal text-sm w-full text-center">
    {{ formName }}
  </p>
  @if(!is_loading){
  <manage-templates
    [removedRightPadding]="true"
    [data]="unlinkedTemplate | filterLinkedKeyList : linkedTemplate"
    [placeHolder]="textBoxPlaceHolder"
    [hub_vault_user_form_id]="-1"
    (selectionChange)="selectConnectedUser($event)"
    [selectedTemplate]="[]"
    [templateConfigurationList]="templateConfigurationList"
  >
  </manage-templates>

  @if (linkedTemplate?.length === 0) {
  <div class="app__centered-item text-center w-full">
    <span class="app__centered-item h-[65%]">
      <span>
        <img [src]="'assets/images/security_key_big_empty_state.svg'" />
        <p class="app__form--attribute--title text-center font-semibold text-[#53565B] mt-2">
          No <span class="font-bold text-[#25508E]"> Encryption Keys </span>to show
        </p>
      </span>
    </span>
  </div>
  }@else{
  <linked-template-list (deleteTemplate)="deleteTemplate($event)" [linkedTemplate]="linkedTemplate" [data]="object_data" [title]="title_type" [fromManageSecurity]="true">
  </linked-template-list>
  } }
</div>
